import { TitleData } from '../../../shared/public-api';
import { BaseComponent } from '../../base/base.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'admin-base-title',
  templateUrl: './base-title.component.html',
  styleUrls: ['./base-title.component.scss'],
  standalone: true,
})
export class BaseTitleComponent extends BaseComponent<TitleData> implements OnInit {
  isAnchor: boolean;
  title: string;
  icon: string;
  id: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.title = this.removeTags(this.data.title);
    this.icon = this.data.icon;
    this.isAnchor = this.data.isAnchor;
    this.id = this.data.id;
  }

  private removeTags(str: string): string {
    if (str === null || str === '') {
      return '';
    }

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, '');
  }
}
